import { FC } from "react";

import { PrimaryText } from "@/components/Typography/Styled";

import { StyledDashboardDangerIcon, StyledDashboardErrorBlock } from "./Styled";

interface IDashboardErrorBlock {
    title: string;
}

export const DashboardErrorBlock: FC<IDashboardErrorBlock> = ({ title }) => {
    return (
        <StyledDashboardErrorBlock>
            <StyledDashboardDangerIcon />
            <PrimaryText>{title}</PrimaryText>
        </StyledDashboardErrorBlock>
    );
};
